import { useRouter } from 'next/router'
import Cookies from 'cookie-universal'
import {
  FreeTrialPromo,
  getFreeTrialPromoAppliedCookie,
  useIsFreeTrialPromoEnabled,
} from '../experiments'
import { Tier } from '../types/checkout'
import { paths } from '../utils/paths'
import { useAuth0User } from './useAuth0User'

export const useFreeTrialData = ({
  promo,
  selectedTier,
  tiers,
  shouldTrackExperimentViewed = false,
}: {
  promo?: FreeTrialPromo
  selectedTier?: Tier
  tiers?: Tier[]
  shouldTrackExperimentViewed?: boolean
} = {}) => {
  const { me } = useAuth0User()
  const isFreeTrialPromoEnabled = useIsFreeTrialPromoEnabled({
    shouldTrackExperimentViewed,
  })
  const { asPath } = useRouter()

  const cookies = Cookies()
  const isFreeTrialEligible =
    isFreeTrialPromoEnabled &&
    !!getFreeTrialPromoAppliedCookie(cookies) &&
    (me ? !!me?.purchaseEligibility?.trialPeriodInDays : true)

  const showInPaymentPage =
    (!!promo?.showPromoInCheckout &&
      !!selectedTier?.internalData.trialDays &&
      isFreeTrialEligible) ||
    false

  const showInMembershipPage =
    (!!promo?.showPromoInCheckout &&
      tiers?.some((tier) => tier.internalData.trialDays) &&
      isFreeTrialEligible) ||
    false

  let freeTrialSuffix = '(non-free trial)'
  if (asPath.includes(paths.personaCheckoutRoot)) {
    freeTrialSuffix = isFreeTrialEligible ? '(free trial)' : '(non-free trial)'
    if (showInMembershipPage || showInPaymentPage) {
      freeTrialSuffix = '(free trial)'
    }
  }

  return {
    isFreeTrialEligible,
    freeTrialSuffix,
    showInPaymentPage,
    showInMembershipPage,
  }
}
